// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"7538":"161dfea8c8d554ac","8946":"ef56d4b77b022312","9983":"8507ec4d86b16289"}[chunkId] + ".js";
};